import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import { PriorityStatusDot } from '../utils/PriorityStatusDot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormattedPriorityStatus = ({
  property,
  value,
  objectTypeId
}) => {
  if (value === null || value === undefined || value === '') {
    return /*#__PURE__*/_jsx("span", {
      children: EMPTY_PROPERTY_VALUE
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(PriorityStatusDot, {
      property: property,
      objectTypeId: objectTypeId,
      value: value
    }), getDisplayedValue(property, value, undefined, undefined, objectTypeId)]
  });
};
export default FormattedPriorityStatus;